type Guide = {
  [k: string]: {
    title: string;
    url: string;
  }
};


export const guideOptions: Guide = {
  bonuses: {
    title: "How to Set Up a Bonus Campaign",
    url: "https://guide.kingsizer.com/content/bonuses-f3a91c4d8c8d1f2a",
  },
  cms: {
    title: "CMS Guide",
    url: "https://guide.kingsizer.com/content/cms-f3a91c4d8c8d1f2a",
  },
  gamecentre: {
    title: "Game Center Guide",
    url: "https://guide.kingsizer.com/content/gamecentre-f3a91c4d8c8d1f2a",
  },
};